import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const DEFAULT_NICHES = ['tech','finance','gaming','lifestyle','fitness','education','travel','food','business'];

const NichesContext = createContext({ niches: DEFAULT_NICHES });

export function NichesProvider({ children }) {
  const [niches, setNiches] = useState(DEFAULT_NICHES);

  useEffect(() => {
    axios.get('/api/settings/niches')
      .then(r => { if (r.data?.data?.length) setNiches(r.data.data); })
      .catch(() => {});
  }, []);

  return (
    <NichesContext.Provider value={{ niches }}>
      {children}
    </NichesContext.Provider>
  );
}

export const useNiches = () => useContext(NichesContext);
